const token = "Bearer ehg12lywm3wnpf9wraaxj3bfaldmdvbzwotb4b0f";

export default token;
